'use client';

import { userExists } from '@velocity-exchange/common';
import { useEffect } from 'react';
import useVelocityAccountStore from 'src/stores/useVelocityAccountsStore';
import useCurrentUserAccount from './useCurrentUserAccount';
import useCurrentWalletAdapter from './useCurrentWalletAdapter';
import useVelocityClient from './useVelocityClient';
import useVelocityClientIsReady from './useVelocityClientIsReady';
import useWalletIsConnected from './useWalletIsConnected';

const useSyncAccountExists = () => {
	const connected = useWalletIsConnected();
	const wallet = useCurrentWalletAdapter();
	const velocityClientIsReady = useVelocityClientIsReady();
	const velocityClient = useVelocityClient();
	const userAccountNotInitialized = useVelocityAccountStore(
		(s) => s.userAccountNotInitialized
	);
	const currentAccountKey = useVelocityAccountStore((s) => s.currentUserKey);
	const currentUserAccount = useCurrentUserAccount();
	const setVelocityAccountStore = useVelocityAccountStore((s) => s.set);

	const getAndSetUserExists = async () => {
		if (!currentUserAccount || !velocityClient) {
			setVelocityAccountStore((s) => {
				s.currentUserExists = false;
			});
			return;
		}

		const accountExists = await userExists(
			velocityClient,
			currentUserAccount.userId,
			currentUserAccount.authority
		);

		setVelocityAccountStore((s) => {
			s.currentUserExists = accountExists;
		});
	};

	useEffect(() => {
		if (!connected || !velocityClientIsReady) {
			setVelocityAccountStore((s) => {
				s.currentUserExists = false;
			});
			return;
		}
		getAndSetUserExists();
	}, [
		connected,
		wallet,
		velocityClientIsReady,
		currentAccountKey,
		userAccountNotInitialized,
		!!currentUserAccount,
	]);
};

export default useSyncAccountExists;
